import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import { useLocation } from "wouter";
import { APP_LOGO, APP_TITLE } from "@/const";

export default function NotFound() {
  const [, setLocation] = useLocation();

  const handleGoHome = () => {
    setLocation("/");
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-primary via-primary/95 to-primary/90">
      <div className="container px-4">
        <div className="max-w-2xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <img src={APP_LOGO} alt={APP_TITLE} className="h-12" />
          </div>

          {/* 404 Number */}
          <div className="mb-6">
            <h1 className="text-9xl font-bold text-white/20 mb-2">404</h1>
            <div className="h-1 w-24 bg-accent mx-auto rounded-full"></div>
          </div>

          {/* Message */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Page Not Found
          </h2>
          
          <p className="text-xl text-white/80 mb-12 leading-relaxed max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={handleGoBack}
              variant="outline"
              size="lg"
              className="bg-white/10 hover:bg-white/20 text-white border-white/30 backdrop-blur-sm"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Go Back
            </Button>
            
            <Button
              onClick={handleGoHome}
              size="lg"
              className="bg-accent hover:bg-accent/90 text-accent-foreground shadow-lg"
            >
              <Home className="w-5 h-5 mr-2" />
              Go Home
            </Button>
          </div>

          {/* Additional Help */}
          <div className="mt-16 pt-8 border-t border-white/20">
            <p className="text-white/60 text-sm">
              Need help? <a href="mailto:info@stanfordlogistics.net" className="text-white hover:text-accent transition-colors underline">Contact us</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
